module.exports = __webpack_public_path__ + "img/7.d3080f59.png";